module.exports = __webpack_public_path__ + "static/media/anuncio@3x.ab9a2260.png";